module.exports = __webpack_public_path__ + "img/僵蚕.815f9c17.jpg";